import { retailOnly } from '~/modules/user/utils/retailOnly';

export interface IMindboxCartItem {
  productId: string | number;
  offerId?: string | number;
  price: number;
  quantity: number;
}

export interface IMindboxWishlistItem {
  productId: string | number;
  price?: number;
}

const call = (operation: string, data: Record<string, unknown>) => {
  if (!import.meta.client) return;
  if (typeof window.mindbox !== 'function') return;

  window.mindbox('async', { operation, data });
};

export const useMindbox = () => {
  const viewProduct = (productId: string | number, price: number) => {
    call('Website.ViewProduct', {
      viewProduct: {
        price,
        product: {
          ids: { website: String(productId) },
        },
      },
    });
  };

  const viewCategory = (categoryId: string | number) => {
    call('Website.ViewCategory', {
      viewProductCategory: {
        productCategory: {
          ids: { website: String(categoryId) },
        },
      },
    });
  };

  const setCart = (items: IMindboxCartItem[]) => {
    call('Website.SetCart', {
      productList: items.map((item) => ({
        count: item.quantity,
        pricePerItem: item.price,
        product: { ids: { website: String(item.productId) } },
      })),
    });
  };

  const clearCart = () => {
    call('Website.ClearCart', {});
  };

  const setWishList = (items: IMindboxWishlistItem[]) => {
    if (!items.length) {
      call('Website.ClearWishList', {});
      return;
    }

    call('Website.SetWishList', {
      productList: items.map((item) => ({
        count: 1,
        pricePerItem: item.price ?? 0,
        product: { ids: { website: String(item.productId) } },
      })),
    });
  };

  return {
    viewProduct: retailOnly(viewProduct),
    viewCategory: retailOnly(viewCategory),
    setCart: retailOnly(setCart),
    clearCart: retailOnly(clearCart),
    setWishList: retailOnly(setWishList),
  };
};
